import React, { FunctionComponent } from 'react';

const SubNavSeparator: FunctionComponent = () => (
  <li className="separator" />
);

export default SubNavSeparator;
